import type { FAQItem } from './types';

export const intercommunityFAQs: FAQItem[] = [
  {
    id: 'intercommunity-overview',
    question:
      'How does community-to-community commerce work (e.g., group buys across neighborhoods)?',
    answer: `Cross-community group purchases are a planned capability, not live today. The design intent is:

• Communities opt in to shared group buys, with privacy-respecting participant lists
• **Service credits** or prorated settlements used for fair cost sharing
• Separate ledgers per community with **transparent settlement exports**
• Governance approvals per community enforced before commitment

This would let nearby communities unlock bulk pricing while keeping finances clean, once built. It depends on the vendor and payment systems described elsewhere in this FAQ, none of which are built yet.`,
    category: 'intercommunity',
  },
  {
    id: 'intercommunity-privacy',
    question: 'What data would be shared between communities during cross-community buys?',
    answer: `This is design intent for a feature that does not exist yet. The plan is to share only **minimal necessary** information:

• Aggregated quantities, delivery windows, and service requirements
• No resident PII shared between communities
• Vendor receiving only what is required to fulfill (e.g., drop-off points)
• Detailed records remaining partitioned per community`,
    category: 'intercommunity',
  },
  {
    id: 'intercommunity-disputes',
    question: 'How would disputes be handled across communities and vendors?',
    answer: `Cross-community dispute handling is planned, not built. The intended design:

• Each community tracks its own deliveries, issues, and approvals
• Evidence (photos, messages) attached to the relevant order lines
• Adjustments flowing through the settlement process before final disbursement
• Audit trails for accountability across all parties

This depends on the settlement and payment infrastructure described above, which does not exist yet.`,
    category: 'intercommunity',
  },
];
